import type { Action } from 'state/actions';
import { addKey, removeKey } from 'state/utils/collection';

import type { QuotesMap } from './quote.model';
import { initialQuotesMap } from './quote.model';

export function quoteReducer(state: QuotesMap = initialQuotesMap, action: Action): QuotesMap {
  switch (action.type) {
    case 'SECONDARY_MARKET_QUOTE_RECEIVED':
      return addKey(state, action.quoteId, action.data);
    case 'SECONDARY_MARKET_QUOTE_CANCELLED':
      return removeKey(state, action.quoteId);
    default:
      return state;
  }
}
